<template>
  <div>
    <b-col
        md="12"
        xl="12"
        class="mb-1"

    >
      <b-card-code title="">
        <b-row>
          <b-col
              md="6"
              xl="6"
          >
            <b-form-group label="Von Datum">
              <b-form-datepicker
                  v-model="edit.From"
                  :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
                  :start-weekday="1"
                  locale="de-DE"
                  color="danger"
              />
            </b-form-group>
          </b-col>

          <b-col
              md="6"
              xl="6"
          >
            <b-form-group label="bis Datum">
              <b-form-datepicker
                  v-model="edit.To"
                  :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
                  :start-weekday="1"
                  locale="de-DE"
                  color="danger"
              />
            </b-form-group>
          </b-col>

        </b-row>

        <b-row>
          <b-col
              md="12"
              xl="12"
              class="mb-1"
          >
            <b-button
                class="col-12"
                variant="success"
                @click="Search()"
            >
              <span v-show="!loading"> Offene Posten anzeigen </span>
              <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
              <div
                  v-show="loading"
                  class="spinner-border spinner-border-sm"
                  role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </b-button>
          </b-col>

        </b-row>

        <b-row>
          <b-col cols="12">
            <b-table
                striped
                hover
                responsive
                :per-page="perPage"
                :items="items"
                :fields="fields"
            >
              <template #cell(Checkbox)="data">
                <b-form-checkbox
                    v-model="data.item.active"
                    class="vs-checkbox-con"
                >
                <span class="vs-checkbox">
                  <span class="vs-checkbox--check">
                    <i class="vs-icon feather icon-check"/>
                  </span>
                </span>
                </b-form-checkbox>
              </template>

              <template #cell(Customer)="data">
                {{ data.item.CustomerNumber }} - {{ data.item.CustomerName }}
              </template>
              <template #cell(PaymentMethod)="data">
                <b-badge
                    v-show="data.item.PaymentMethod == 3 && data.item.CommissionSum > 0"

                    class="mt-1 mr-1"
                    variant="info"
                >Gutschrift
                </b-badge>
                <b-badge
                    v-show="data.item.PaymentMethod == 1"

                    class="mt-1 mr-1"
                    variant="success"
                >Rechnung
                </b-badge>
                <b-badge
                    v-show="data.item.PaymentMethod == 2"

                    class="mt-1 mr-1"
                    variant="info"
                >Lastschrift
                </b-badge>

              </template>
              <template #cell(CommissionSum)="data">
                {{FormatEuro(data.item.CommissionSum)}}
              </template>
            </b-table>

            <b-button
                :disabled="disableCreate"
                class="col-4"
                variant="info"
                @click="CreateInvoice()"
            >
              <span v-show="!disableCreate"> Rechnungen erstellen </span>
              <feather-icon
                  v-show="disableCreate"
                  icon="LockIcon"
                  size="22"
              />
            </b-button>
          </b-col>
        </b-row>
      </b-card-code>
    </b-col>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
  BButton,
  BCol, BFormCheckbox, BFormDatepicker, BFormGroup, BFormInput, BRow, BTable,
  BBadge,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'BillingInformation',
  components: {
    BTable,
    BFormCheckbox,
    BFormDatepicker,
    BCardCode,
    BFormInput,
    BFormGroup,
    BButton,
    BRow,
    BCol,
    BBadge,
  },

  data() {
    return {
      perPage: 25,
      loading: false,
      disableCreate: true,
      edit: {
        From: '',
        To: ''
      },
      fields: [
        {
          key: 'Checkbox',
          label: '',
        },
        {
          key: 'Customer',
          label: 'Kunde',
        },
        {
          key: 'VoucherCount',
          label: 'Offene Posten',
        },
        {
          key: 'NetSum',
          label: 'Netto Summe',
        },
        {
          key: 'CommissionSum',
          label: 'Provision Summe',
        },
        {
          key: 'PaymentMethod',
          label: 'Art',
        },
      ],
      items: [],
      invoiceItems: [],
    }
  },
  created() {
    this.$watch(
        () => this.edit.From,
        val => {
          this.Reset();
        },
    )
    this.$watch(
        () => this.edit.To,
        val => {
          this.Reset();
        },
    )
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Rechnungslauf'
    })
  },
  methods: {
    Reset() {
      this.disableCreate = true
      this.items = []
      this.invoiceItems = []
    },
    CreateInvoice() {
      this.invoiceItems = [];
      this.creditNoteItems = [];
      let edit = Object.assign({}, this.edit)
      edit.From != '' ? edit.From = new Date(this.edit.From.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1')) : ''
      edit.To != '' ? edit.To = new Date(this.edit.To.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1')) : ''
      Object.keys(this.items)
          .forEach(key => {
            if (this.items[key]['active'] == true) {
              if (this.items[key]['PaymentMethod'] == 1) {
                this.invoiceItems.push(this.items[key]['CustomerIdentId'])
              }
              if (this.items[key]['CommissionSum'] > 0) {
                this.creditNoteItems.push(this.items[key]['CustomerIdentId'])
              }
            }
          })

      this.$http.post('invoice/createInvoiceRun', JSON.stringify({
        Customers: this.invoiceItems,
        CreditNoteCustomers: this.creditNoteItems,
        From: edit.From,
        To: edit.To,
      }))
          .then(resp => {
            if (resp.data.success) {

              this.loading = false
              this.items = []

              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Rechnungen wurden erstellt.',
                  variant: 'success',
                },
              })
            } else {
              this.loading = false
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'CheckIcon',
                  text: resp.data.message,
                  variant: 'danger',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },

    FormatEuro(euro) {
      return this.$options.filters.currency(euro)
    },
    Search() {
      let edit = Object.assign({}, this.edit)

      this.items = []
      this.loading = true
      edit.From != '' ? edit.From = new Date(this.edit.From.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1')) : ''
      edit.To != '' ? edit.To = new Date(this.edit.To.replace(/(.*)\.(.*)\.(.*)/, '$3-$2-$1')) : ''
      this.$http.post('invoice/searchVacantPositions', JSON.stringify(edit))
          .then(resp => {
            if (resp.data.success) {
              Object.keys(resp.data.list)
                  .forEach(key => {
                    resp.data.list[key]['NetSum'] = resp.data.list[key]['NetSum'].toLocaleString('de-DE', {
                      style: 'currency',
                      currency: 'EUR',
                      minimumFractionDigits: 2
                    })

                    this.items.push(resp.data.list[key])
                  })
              if (this.items.length > 0) {
                this.disableCreate = false
              }
              this.loading = false
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Offene Posten abgerufen.',
                  variant: 'success',
                },
              })
            } else {
              this.loading = false
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'CheckIcon',
                  text: resp.data.message,
                  variant: 'danger',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    }
  },
}
</script>

<style scoped>

</style>
